import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
} from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { FullscreenPhotoComponent } from "../fullscreen-photo/fullscreen-photo.component";
import { PictureInfo } from "../photo-viewmodel";

@Component({
  selector: "app-multi-delete",
  templateUrl: "./multi-delete.component.html",
  styleUrls: ["./multi-delete.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultiDeleteComponent implements OnInit {
  @Input() photos: PictureInfo[];
  @Output() selectedPhotos = new EventEmitter<PictureInfo[]>();
  @Output() cancel = new EventEmitter<void>();

  selected: PictureInfo[] = [];

  isLongPress = false;

  constructor(
    private _sanitizer: DomSanitizer,
    private _modalService: NgbModal
  ) {}

  ngOnInit(): void {
    document
      .getElementById("multiDeleteWrapper")
      .style.setProperty("--height", `${window.innerHeight - 4}px`);
  }

  @HostListener("window:resize")
  onResize() {
    document
      .getElementById("multiDeleteWrapper")
      .style.setProperty("--height", `${window.innerHeight - 4}px`); // otherwise you get a scrollbar on mobile :(
  }

  transform(value: string): SafeHtml {
    return this._sanitizer.bypassSecurityTrustResourceUrl(value);
  }

  isSelected(photo: PictureInfo) {
    return this.selected.findIndex((p) => p.data.id == photo.data.id) !== -1;
  }

  toggleSelection(photo: PictureInfo) {
    if (this.isSelected(photo))
      this.selected = this.selected.filter((p) => p.data.id != photo.data.id);
    else this.selected.push(photo);
  }

  submitSelected() {
    if (this.selected.length) this.selectedPhotos.emit(this.selected);
  }

  close() {
    this.cancel.emit();
  }

  viewImage(photo: PictureInfo) {
    const modalRef = this._modalService.open(FullscreenPhotoComponent, {
      windowClass: "fullscreen-modal",
    });
    modalRef.componentInstance.photo = photo;
  }

  handlePress(photo: PictureInfo) {
    this.isLongPress = true;
    this.toggleSelection(photo);
  }

  handlePressUp(photo: PictureInfo) {
    if (!this.isLongPress) this.viewImage(photo);
    this.isLongPress = false;
  }

  stopContextMenu(event) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    return false;
  }
}
